import { mergeDeepRight } from 'ramda';

export const SET_LOCATION_VALUES = 'DRSA/LOCATION/SET_LOCATION_VALUES';
export const RESET_HIGHWAY_LOCATION_VALUES = 'DRSA/LOCATION/RESET_HIGHWAY_LOCATION_VALUES';

const initialState = {};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_LOCATION_VALUES:
      return mergeDeepRight(state)(action.payload);
    case RESET_HIGHWAY_LOCATION_VALUES:
      return mergeDeepRight(state)({ highwayLocation: undefined });
    default:
      return state;
  }
};

export const storeData = ({ payload }) => ({ type: SET_LOCATION_VALUES, payload });

export const storeReferentialHighway = ({ payload }) => ({
  type: SET_LOCATION_VALUES,
  payload: { highwayLocation: { highway: payload?.code, highwayName: payload?.name } },
});

export const storeHighwayDirection = ({ payload }) => ({
  type: SET_LOCATION_VALUES,
  payload: { highwayLocation: { direction: payload } },
});

export const storeHighwayPointOfInterest = ({
  payload: { country, directionTo, directionFrom, sectionCode, sectionName, extId, type, title, milestone, lat, lng },
}) => ({
  type: SET_LOCATION_VALUES,
  payload: {
    highwayLocation: {
      country,
      directionTo,
      directionFrom,
      section: sectionCode,
      sectionName,
      pointOfInterest: extId,
      pointOfInterestType: type,
      pointOfInterestName: title,
      milestone,
      pointOfInterestLat: lat,
      pointOfInterestLng: lng,
    },
  },
});

export const resetHighwayLocationValues = () => ({ type: RESET_HIGHWAY_LOCATION_VALUES });

const actions = {
  storeData,
  storeReferentialHighway,
  storeHighwayDirection,
  storeHighwayPointOfInterest,
  resetHighwayLocationValues,
};

export default { reducer, actions };
